import { useController } from "react-hook-form";
import { FieldError } from "../FieldError";
import { Label } from "../../../../components/ui/label";
import { Input } from "../../../../components/ui/input";
import { useEffect } from "react";
import { getPeriodLabels } from "../../utils/periodLabels";

function NumberWithCommasInput({ name, label, control }) {
  const {
    field: { onChange, value = "", ref },
  } = useController({ name, control });

  // Format number with commas
  const formatNumber = (val) => {
    if (val === "" || val === null || val === undefined || isNaN(val)) return "";
    return Number(val).toLocaleString("en-US");
  };

  // Remove commas and parse to number
  const parseNumber = (val) => {
    if (!val) return null;
    const num = String(val).replace(/,/g, "");
    return num === "" ? null : Number(num);
  };

  const handleChange = (e) => {
    const raw = parseNumber(e.target.value);
    onChange(raw);
  };

  return (
    <div className="space-y-1">
      <Label htmlFor={name}>{label}</Label>
      <Input
        id={name}
        ref={ref}
        value={formatNumber(value)}
        onChange={handleChange}
        placeholder={`Enter ${label}...`}
        inputMode="numeric"
      />
      <FieldError name={name} control={control} />
    </div>
  );
}

export function Miles({ control, carriers, setValue }) {
  const labels = getPeriodLabels({ withMilesSuffix: true });

  const fields = [
    { name: "step2.miles.projected", label: labels.projected },
    { name: "step2.miles.current", label: labels.current },
    { name: "step2.miles.firstPrior", label: labels.firstPrior },
    { name: "step2.miles.secondPrior", label: labels.secondPrior },
  ];

  useEffect(() => {
    if (!carriers?.includes("Accelerant")) {
      setValue("step2.miles", undefined, { shouldDirty: true, shouldValidate: true });
    }
  }, [carriers]);

  return (
    <>
      {carriers?.includes("Accelerant") && (
        <div className="space-y-4">
          <div className="text-lg font-semibold">Miles</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {fields.map((f) => (
              <NumberWithCommasInput key={f.name} {...f} control={control} />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
